<template>
  <div class="modal" :class="{ 'is-active': is_open }">
    <div class="modal-background" @click="close"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ is_editing ? $t("edit request") : $t("new request") }}
        </p>
        <button class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="save">
          <div class="columns">
            <div class="column is-two-thirds">
              <!-- Customer Name -->
              <!-- <div class="field"> -->
              <label class="label">{{ $t("customer name") }} *</label>
              <div class="control">
                <input
                  type="text"
                  class="input"
                  v-model="form.customer_name"
                  :placeholder="$t('enter customer name')"
                  required
                />
              </div>
              <!-- </div> -->
            </div>
            <div class="column">
              <!-- NIT -->
              <!-- <div class="field"> -->
              <label class="label">{{ $t("nit") }} *</label>
              <div class="control">
                <input
                  type="text"
                  class="input"
                  v-model="form.nit"
                  :placeholder="$t('enter nit')"
                  maxlength="50"
                />
              </div>
              <!-- <p class="help">{{ $t("nit is optional") }}</p> -->
              <!-- </div> -->
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <!-- DPI -->
              <!-- <div class="field"> -->
              <label class="label">{{ $t("dpi") }} *</label>
              <div class="control">
                <input
                  type="text"
                  class="input"
                  v-model="form.dpi"
                  :placeholder="$t('enter dpi')"
                  maxlength="50"
                />
              </div>
              <!-- <p class="hel">{{ $t("dpi is optional") }}</p> -->
              <!-- </div> -->
            </div>
            <div class="column">
              <!-- Pagare Number -->
              <!-- <div class="field"> -->
              <label class="label">{{ $t("pagare number") }}</label>
              <div class="control">
                <input
                  type="text"
                  class="input"
                  v-model="form.pagare_number"
                  :placeholder="$t('enter pagare number')"
                  maxlength="100"
                />
              </div>
              <!-- <p class="help">{{ $t("pagare number must be unique") }}</p> -->
              <!-- </div> -->
            </div>
          </div>

          <!-- Status (only for editing) -->
          <div class="field" v-if="is_editing">
            <label class="label">{{ $t("status") }}</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="form.status">
                  <option value="pending">{{ $t("pending") }}</option>
                  <option value="in_progress">{{ $t("in progress") }}</option>
                  <option value="completed">{{ $t("completed") }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <!-- Segment -->
              <label class="label">{{ $t("segment") }}</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="form.segment">
                    <option value="">{{ $t("select one") }}</option>
                    <option value="plus">{{ $t("plus") }}</option>
                    <option value="extra">{{ $t("extra") }}</option>
                    <option value="premium">{{ $t("premium") }}</option>
                    <option value="ultra">{{ $t("ultra") }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column">
              <!-- Additional Settings -->
              <label class="label">{{ $t("call id") }}</label>
              <div class="control">
                <input
                  type="text"
                  class="input"
                  v-model="form.settings.call_id"
                  :placeholder="$t('enter call id')"
                />
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <!-- Income -->
              <label class="label">{{ $t("income") }}</label>
              <div class="control">
                <input
                  type="text"
                  class="input"
                  v-model="form.settings.income"
                  :placeholder="$t('enter income')"
                />
              </div>
            </div>
            <div class="column">
              <!-- Email -->
              <label class="label">{{ $t("email") }}</label>
              <div class="control">
                <input
                  type="text"
                  class="input"
                  v-model="form.settings.email"
                  :placeholder="$t('enter email')"
                />
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <!-- Phone number -->
              <label class="label">{{ $t("phone number") }}</label>
              <div class="control">
                <input
                  type="text"
                  class="input"
                  v-model="form.settings.phone_number"
                  :placeholder="$t('enter phone number')"
                />
              </div>
            </div>
            <div class="column"></div>
          </div>

          <!-- Additional Notes -->
          <!-- <div class="field">
            <label class="label">{{ $t("additional notes") }}</label>
            <div class="control">
              <textarea
                class="textarea"
                v-model="form.notes"
                :placeholder="$t('enter additional notes')"
                rows="3"
              ></textarea>
            </div>
          </div> -->
        </form>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-success is-rounded"
          @click="save"
          :disabled="is_loading"
        >
          <span class="icon" v-if="is_loading">
            <i class="fa fa-spinner fa-spin"></i>
          </span>
          <span class="icon" v-else>
            <i class="fa fa-save"></i>
          </span>
          <span>{{ $t("save") }}</span>
        </button>
        <button class="button is-rounded ml-3" @click="close">
          {{ $t("cancel") }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { get, post, put, success_message, error_message } from "@/utils";

export default {
  name: "CreditAnalysisRequestModal",
  data() {
    return {
      is_open: false,
      is_editing: false,
      is_loading: false,
      uuid: null,
      form: {
        customer_name: "",
        nit: "",
        dpi: "",
        pagare_number: "",
        status: "pending",
        notes: "",
        settings: {},
      },
    };
  },
  methods: {
    open(uuid = null) {
      this.uuid = uuid;
      this.is_editing = !!uuid;
      this.is_open = true;

      if (this.is_editing) {
        this.loadRequest();
      } else {
        this.resetForm();
      }
    },
    close() {
      this.is_open = false;
      this.resetForm();
    },
    resetForm() {
      this.form = {
        customer_name: "",
        nit: "",
        dpi: "",
        pagare_number: "",
        status: "pending",
        notes: "",
        settings: {},
      };
    },
    loadRequest() {
      this.is_loading = true;

      get("/credit-analysis/request", { uuid: this.uuid })
        .then((response) => {
          const data = response;
          this.form = {
            customer_name: data.customer_name || "",
            nit: data.nit || "",
            dpi: data.dpi || "",
            pagare_number: data.pagare_number || "",
            status: data.status || "pending",
            notes: (data.settings && data.settings.notes) || "",
            segment: data.segment || "",
            settings: data.settings || {},
          };
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    save() {
      if (
        !this.form.customer_name.trim() ||
        !this.form.segment ||
        !this.form.nit.trim() ||
        !this.form.dpi.trim()
      ) {
        error_message(
          this.$t("customer name, nit, dpi and segment are required")
        );
        return;
      }

      this.is_loading = true;

      // Prepare settings object
      const settings = {
        ...this.form.settings,
        notes: this.form.notes,
        segment: this.form.segment,
      };

      const data = {
        customer_name: this.form.customer_name.trim(),
        nit: this.form.nit.trim() || null,
        dpi: this.form.dpi.trim() || null,
        pagare_number: this.form.pagare_number.trim(),
        status: this.form.status,
        settings: Object.keys(settings).length > 0 ? settings : null,
      };

      if (this.is_editing) {
        data.uuid = this.uuid;
        post("/credit-analysis/request", data)
          .then(() => {
            success_message(this.$t("request updated successfully"));
            this.$emit("saved");
            this.close();
          })
          .catch((error) => {
            error_message(error);
          })
          .finally(() => {
            this.is_loading = false;
          });
      } else {
        put("/credit-analysis/request", data)
          .then(() => {
            success_message(this.$t("request created successfully"));
            this.$emit("saved");
            this.close();
          })
          .catch((error) => {
            error_message(error);
          })
          .finally(() => {
            this.is_loading = false;
          });
      }
    },
  },
};
</script>

<style scoped>
.modal-card {
  width: 90%;
  max-width: 600px;
}

.help {
  font-size: 0.875rem;
  color: #888;
}

.field {
  margin-bottom: 1.5rem;
}
</style>
